import React from 'react';
import { useTranslation } from 'react-i18next'; // Import i18n translation hook
import './Footer.css'; // Add styling here

function Footer() {
  const { t } = useTranslation(); // Use translation function

  return (
    <div className="footer">
      <div className="footer-links">
        <a href="#customer-service">{t('footer.customerService')}</a>
        <a href="#faq">{t('footer.faq')}</a>
        <a href="#shopping-guide">{t('footer.shoppingGuide')}</a>
      </div>

      <div className="contact-section">
        <span className="contact-title">{t('footer.contactUs')}</span>
        <div className="contact-icons">
          <img src="/Footer/wechat_logo.png" alt="WeChat" className="contact-icon" />
          <img src="/Footer/phone_logo.png" alt="Phone" className="contact-icon" />
        </div>
      </div>
    </div>
  );
}

export default Footer;